import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { TimelineResponse } from '../types';

export function useTimeline(
  familyId: string | undefined,
  childFilter: string | null,
  mediaIdsFilter?: string | null,
) {
  const apiClient = useApiClient();

  return useInfiniteQuery({
    queryKey: ['timeline', familyId, childFilter, mediaIdsFilter],
    queryFn: ({ pageParam }) => {
      const params = new URLSearchParams();
      if (pageParam) params.set('cursor', pageParam);
      params.set('limit', '20');
      if (childFilter) params.set('childId', childFilter);
      if (mediaIdsFilter) params.set('ids', mediaIdsFilter);
      return apiClient.get<TimelineResponse>(
        `/api/families/${familyId}/media?${params.toString()}`
      );
    },
    initialPageParam: null as string | null,
    getNextPageParam: (lastPage) => lastPage.nextCursor,
    enabled: !!familyId,
  });
}
